import { onboardingRequestDetailApi } from '../api/OnboardingRequestDetailApi'

class ProcessesProgressService {
  public fetchRequestProcessesProgress = (requestId: string) => {
    return onboardingRequestDetailApi.getRequestProcessesProgress(+requestId)
  }
}

export const processesProgressService = new ProcessesProgressService()
